angular.module('festzelt-os.modules.exports', [
    'festzelt-os.components'
]);

require('./routes');

require('./store/exports');



// WEBPACK FOOTER //
// ./src/app/modules/exports/module.js